module.exports = __webpack_public_path__ + "assets/img/deleteHover.0a342218.svg";